export const iconFontAwesomeMoneyLitecoinSign = (
	<i className="fa-solid fa-litecoin-sign"></i>
);
